import { useLocation } from "react-router-dom";
import StepProgressBar from "@src/components/ProgressBar";
import Layout from "@src/components/shared/Layout";
import { useShowProgress } from "@src/helpers/useShowProgress";
import { cn } from "@src/lib/utils";

function Container({
  children,
  className,
  containerWith = "656px",
}: {
  children: JSX.Element | JSX.Element[];
  className?: string;
  containerWith?: string;
}) {
  const location = useLocation();
  const { show, progress } = useShowProgress(location.pathname);

  return (
    <Layout>
      <div
        className={cn(
          "mb-2 flex w-full justify-center mt-24 max-md:min-h-[90vh] px-4",
          className
        )}
      >
        <div
          className={`flex w-full flex-col rounded-xl px-0 max-sm:gap-4  md:mx-8 sm:bg-white md:px-8`}
          style={{ maxWidth: containerWith }}
        >
          {show ? (
            <div className="flex w-full justify-center px-4 py-7">
              <div className="w-full">
                <StepProgressBar progress={progress} />
              </div>
            </div>
          ) : null}
          {children}
        </div>
      </div>
    </Layout>
  );
}

export default Container;
